import React, { Component } from 'react';
import './../css/master.css';
import './../css/width.css';
import Header from './../js/header.js';
import axiosInstance from '../api/csAxios';
import $ from 'jquery';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

var httpURL 		= '';
var queryString 	= require('querystring');
var lstWidth 		= [];
var COL_WIDTHID 	= 'td:eq(0)';
var COL_WIDTH 		= 'td:eq(1)';

class Width extends Component {
  constructor(props){
	super(props);
	this.state={
		width:[],
		flg:true,
		loader:'none',
		opacity:1,
	}
  }
  
  componentDidMount =()=> {
	this.setState({loader:'block', opacity:0.5});  
	  axiosInstance.get(httpURL+'/a/mst/wdh/list',{
		  withCredentials: true
	  }).then((response)=> {
			if(response.data.SvcStatus === 'Success'){
				this.setState({
					width:response.data.lstWidth,
				})
				lstWidth = this.state.width;
				this.setWidthTable();
			}
			else{
				toast.error(response.data.SvcMsg);
				if(response.data.SvcMsg == 'You are not logged in'){
					window.location.href = window.CSURL;
					return false;
				}
			}
			this.setState({loader:'none', opacity:1});
		}).catch((error)=> {
			toast.error("Service failed " + error);
	  }); 
  }
  
  setWidthTable =()=> {
		$('#widthTableBody tr').remove();
		var table 			= document.getElementById('widthTable');
		var tbody 			= document.getElementById('widthTableBody');
		var filterWidth 	= $('#width').val().toLowerCase();
		
		for(var i=0; i<lstWidth.length; i++){
		var id 		= lstWidth[i].widthId;
		var width	= lstWidth[i].width;
		
		var row = document.createElement('tr');
			row.id = id;
		row.onclick =(e)=>{
			$(e.target).closest('tr').addClass('selected').siblings().removeClass('selected');
			this.setWidthForm($(e.target).closest('tr').attr('id'));
			this.setState({flg:false})
		}
		
		if(width.toLowerCase().indexOf(filterWidth) === -1)
			continue;
		
		this.addTD(row, id, 'no-display');
		this.addTD(row, width, '');
		
		tbody.append(row);
		}
	table.append(tbody);
	}
	
	addTD(row, val, classname){
		var cell = document.createElement('td');
		cell.className = classname;
		var text = document.createTextNode(val);
		cell.append(text);
		row.append(cell);
	}
	
	setWidthForm =(id)=> {
		var widthData = this.getWidthData(id);
		if(widthData !== -1){
			$('#inp_width').val(widthData.width);
		}
	}
	
	getWidthData(id){
		for(var i = 0; i < lstWidth.length; i++){
			if(id == lstWidth[i].widthId){
				return lstWidth[i];
			}
		}
		return -1;
	}
	
	addWidthReady =()=>{
		$('#widthAddForm').trigger('reset');
		this.setState({flg:true})
	}
	
	maintainWidth =()=>{
		if(this.state.flg){
			this.addWidth();
		}else{
			this.editWidth();
		}
	}
	
	addWidth=()=>{
	var widthArr 	= {};
	var width		= $('#inp_width').val().toUpperCase();
	if(width == ''){
		toast.warning('Please fill width');
		document.getElementById('inp_width').focus();
		return false;
	}
	
	widthArr={'widthId': 0, 'width':width}
	this.setState({loader:'block', opacity:0.5});
	axiosInstance.post(httpURL+'/a/mst/wdh/save', 
		queryString.stringify({'width':JSON.stringify(widthArr)}), {withCredentials:true}
	).then((response)=>{	
		if(response.data.SvcStatus === "Success"){
			toast.success(response.data.SvcMsg);
			widthArr.widthId = response.data.widthId;
			lstWidth.push(widthArr);
			this.setWidthTable();
			this.setWidthForm(response.data.widthId);
			this.highlightRow('widthTableBody', response.data.widthId);
			this.setState({flg : false})
		}
		else{
			toast.error(response.data.SvcMsg);
		}
		this.setState({loader:'none', opacity:1});
 	}).catch((e)=>{
         toast.error("Service failed "+e);
  	});
  }

	editWidth=()=>{
		var widthArr 	= {};
		var widthId 	= $('#widthTableBody tr.selected').find(COL_WIDTHID).text();
		var width		= $('#inp_width').val().toUpperCase();
		
		if(widthId == ''){
			toast.warning('Please select row');
			return false;
		}
		
		if(width == ''){
			toast.warning('Please fill width');
			document.getElementById('inp_width').focus();
			return false;
		}
		
		widthArr={'widthId': widthId, 'width':width}
		this.setState({loader:'block', opacity:0.5});
		axiosInstance.post(httpURL+'/a/mst/wdh/save', 
			queryString.stringify({'width':JSON.stringify(widthArr)}), {withCredentials:true}
		).then((response)=>{	
			if(response.data.SvcStatus === "Success"){
				toast.success(response.data.SvcMsg);
				var widthIdx = this.getIdxWidth(widthId);
				lstWidth.splice(widthIdx,1,widthArr);
				this.setWidthForm(widthId);
				this.setWidthTable();
				this.highlightRow('widthTableBody', widthId);
			}
			else{
		        toast.error(response.data.SvcMsg);
			}
			this.setState({loader:'none', opacity:1});
		}).catch((e)=>{
			toast.error("Service failed "+e);
		});
	}

	getIdxWidth(widthId){
		for(var i=0; i<lstWidth.length; i++){
			if(lstWidth[i].widthId == widthId){
				return i;
			}
		}
		return -1;
	}

	highlightRow(table, id){
		$('#'+table+' tr').each(function(){
			var widthId = $(this).find(COL_WIDTHID).text();
			if(widthId == id){
				$(this).addClass('selected').siblings().removeClass('selected');
			}
		});
	}

	
  render() {
	httpURL = window.httpURL;
	return (
		<div style={{height:'100%'}}>
			<Header />
			<ToastContainer autoClose={2000} hideProgressBar />
			<div style={{position:'fixed', width:100, height:100, marginLeft:-50, marginTop:-50, left:'50%', top:'50%', display:this.state.loader}}>
				<img src={require("../images/loader.gif")} alt="Loader..."/>
			</div> 
			<div className="main" style={{opacity:this.state.opacity}}>
				<div className="container-fluid">
					<div className="col-sm-7 col-centered">
						<div className="col-sm-5 col-xs-11 padding-remove">
							<table className="tableLayout">
								<thead>
									<tr>
										<th style={{width:50, display:'none'}}>Width Id</th>
										<th style={{width:100}}>
											<input onChange={this.setWidthTable} type="text" className="form-control inp-search" id="width" placeholder="Width" />
										</th>
									</tr>
								</thead>
							</table>
							<div className="widthTableDiv col-sm-12 col-xs-11 padding-remove">
								<table id="widthTable" className="tableLayout">
									<colgroup>
										<col width="100" />
									</colgroup>
									<tbody id="widthTableBody"></tbody>
								</table>
							</div>
						</div>
						<div className="col-sm-1 col-xs-1">
							<span id="addWidth" title="Add Width" onClick={this.addWidthReady} className="addIcon glyphicon glyphicon-plus-sign"></span>
						</div>
						<div className="col-sm-6 col-xs-12">
							<form id="widthAddForm" className="form-horizontal">
								<div className="form-group">
									<label className="control-label col-sm-5">Width:</label>
									<div className="col-sm-7">
										<input type="text" maxLength={30} className="form-control" placeholder="Width" id="inp_width"/>
									</div>
								</div>
								<div className="form-group" style={{marginTop:50}}>
									<div className="col-sm-12 text-center">
										<button type="button" onClick={this.maintainWidth} className="btn btn-warning">Save</button>
									</div>
								</div>
							</form>
						</div>
					</div>
				</div>
			</div>
		</div>
    );
  }
}

export default Width;
